import React from 'react';

import { StyleSheet } from 'react-native';

import { InnerLayout, LayoutContainer } from 'components/layout/styled';
import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

type BackgroundBoxProps = BoxProps & {
  backgroundColor?: string;
};

export const ProductSelectionsContainer = ({
  backgroundColor,
  style,
  ...props
}: BackgroundBoxProps) => (
  <Box {...props} style={[styles.productSelectionsContainer, { backgroundColor }, style]} />
);

export const ProductHomeInnerLayout = InnerLayout.withConfig<{ $isFullContainer?: boolean }>(
  ({ $isFullContainer }) => ({
    paddingY: 0,
    marginY: 0,
    ...($isFullContainer && { padding: 0, margin: 0 }),
  })
);

export const ProductHomeLayoutContainer = LayoutContainer.withConfig<{
  backgroundColor?: string;
  isFullContainer?: boolean;
}>({
  marginY: 0,
  paddingY: 0,
});

export const BottomWrapper = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[styles.bottomWrapper, isDesktop && styles.bottomWrapperDesktop, style]}
    />
  );
};

const styles = StyleSheet.create({
  bottomWrapper: {
    marginVertical: 16,
  },
  bottomWrapperDesktop: {
    marginVertical: 32,
  },
  productSelectionsContainer: {
    width: '100%',
  },
});
